import React, { useEffect } from 'react';
import { Alert } from 'react-bootstrap';

function AlertMassage({ show, type, title, massage, hideAlert }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      hideAlert();
    }, 10000);

    return () => clearTimeout(timer); // cleanup on unmount
  }, []);
  return (
    <Alert variant={type} onClose={hideAlert} dismissible className={`${show?'slide-in-container':''}`}>
      <Alert.Heading className='fs-5'>{title}</Alert.Heading>
      {massage}
    </Alert>
  );
}

export default AlertMassage;